<div class="fixed-panel-container">
  <ng-content></ng-content>

  <app-feedback [hidden]="editMode || hideFooter"></app-feedback>
</div>
